/* tslint:disable */

/**
 */
export class DimaResults {
    DIMA_TYPE?: number;
    ID_DIMA_RESULTS?: number;
    SETPOINT?: number;
    DIMA_STATUS?: number;
    DIMA_TS?: number;
    DIMA_TFP?: number;
    DIMA_VEP?: number;
    DIMA_VC?: number;
    ID_STUDY_EQUIPMENTS?: number;
    DIMA_PRECIS?: number;
    CRYOCONSPROD?: number;
    HOURLYOUTPUTMAX?: number;
    CONSUM?: number;
    USERATE?: number;
    CONSUMMAX?: number;
    USERATEMAX?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/dima-results.ts